import {useEffect} from 'react'
import {ExtendModalHeader} from './ExtendModalHeader'
import {ExtendModalFormWrapper} from './ExtendModalFormWrapper'


const ExtendModal = ({setSelectedBookingId, fetchBooking, selectedBookingId, bookingDetails, setOpenExtendModal}) => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])



  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className={`modal-dialog modal-dialog-centered mw-650px`}>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ExtendModalHeader setSelectedBookingId={setSelectedBookingId}selectedBookingId={selectedBookingId} setOpenExtendModal={setOpenExtendModal}/>
            {/* begin::Modal body */}
            <div className={`modal-body scroll-y mx-5  mx-xl-15 my-7 mt-0`}>
              <ExtendModalFormWrapper  setSelectedBookingId={setSelectedBookingId} fetchBooking={fetchBooking} selectedBookingId={selectedBookingId} bookingDetails={bookingDetails} setOpenExtendModal={setOpenExtendModal}/>
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {ExtendModal}
